import React from "react"
import { Box, Flex, SimpleGrid } from "@chakra-ui/react"
import pluralize from "pluralize"
import BadgeTemplateCard from "components/BadgeBuilder/BadgeTemplateCard/BadgeTemplateCard"
import Button from "components/Buttons/Button"
import HorizontalStat from "components/elements/HorizontalStat"
import EventPage, { EventPageHeader } from "components/layout/EventPage"
import { useHistory } from "react-router-dom"
import { useBadges } from "queries/badges"
import { BadgeTemplate } from "sharedTypes/badge"
import { eventBadgesPath } from "utilities/routes"
import useFeatures from "services/useFeatures"
import Spinner from "components/elements/Spinner"
import { sortBadgeTemplates } from "components/BadgeBuilder/utils/badgeHelpers"
import NoBadges from "./NoBadges"
import BadgeUpgradeAlert from "./BadgeUpgradeAlert"

const BadgeTemplates = ({
  eventId,
  onCreateNew,
}: {
    eventId: string
    onCreateNew: () => void
  }) => {
  const history = useHistory()
  const { isLoading, data } = useBadges(eventId)
  const { badgePrinting } = useFeatures()

  const eventBadges = sortBadgeTemplates(data?.data || [])

  const totalTemplates = eventBadges.length

  const handleTemplateClick = (template: BadgeTemplate) => {
    history.push(`${eventBadgesPath(eventId)}/${template.id}/edit`)
  }

  const content = (
    <>
      {totalTemplates === 0 ? (
        <NoBadges
          badgePrinting={badgePrinting}
        />
      ) : (
        <EventPage
          header={(
            <EventPageHeader
              icon="badges"
              title="Badges"
              items={(
                <Flex align="center" gap={4} minH={9}>
                  <HorizontalStat
                    label={pluralize("Event Template", totalTemplates)}
                    value={totalTemplates}
                  />
                  <Button leftIcon="plus" onClick={() => onCreateNew()} size="sm">
                    Badge
                  </Button>
                </Flex>
              )}
            />
          )}
          body={(
            <>
              <Box overflowX="clip" p={8}>
                {!badgePrinting && (
                <Flex mx="auto" mb={8} justify="center">
                  <BadgeUpgradeAlert />
                </Flex>
                )}
                <SimpleGrid
                  columns={{
                    base: 1, md: 2, xl: 3, "2xl": 4,
                  }}
                  spacing={6}
                  maxW="8xl"
                >
                  {eventBadges.map((template) => (
                    <BadgeTemplateCard
                      key={template.id}
                      template={template}
                      onClick={() => handleTemplateClick(template)}
                    />
                  ))}
                </SimpleGrid>
              </Box>
            </>
            )}
        />
      )}
    </>
  )

  if (isLoading) {
    return <Spinner />
  }

  return content
}

export default BadgeTemplates
